;(function($, undefined){

    var rnn = window.rnn;
    var pathname = window.rnnTreeMenuPathname || window.location.pathname;

    // Initialise the tree menu
    function initTreeMenu() {
        var $primaryNav = $('.primaryNav');
        var $navLinks = $primaryNav.find('a');
        var $secondaryNav = $('.desktopNav');

        $('.hamburger-toggle, .close-nav').click(function () {
            $primaryNav.toggleClass('active');
            $('body').toggleClass('frozen');
        });

        $(document).click(function(e) {
            if (e.target.className === "nav-overlay") {
                $primaryNav.removeClass('active');
                $('body').removeClass('frozen');
            }
        });

        selectNavPage($primaryNav);
        selectNavPage($secondaryNav);

        localBanners();
    }

    function selectNavPage($nav) {
        var $navLinks = $nav.find('a');
        var $navBasedPageBanner = $('.navBasedPageBanner');

        // Attempt to activate the current URL
        _($navLinks)
        .chain()
        .filter(function (el) {
            // Don't include the 'homepage'
            return $(el).attr('href') !== '/';
        })
        .sortBy(function (el) {
            // Order by longest URL to match deeper links first
            return $(el).attr('href').length * -1;
        })
        .every(function (el) {
            var $navLink;
            $navLink = $(el);

            if (pathname.indexOf($navLink.attr('href')) >= 0) {
                // Stories all begin with /news/ so the News > Local menu item
                // should only be highlighed if it's an exact match
                if ($navLink.attr('href') === '/news/' && pathname !== '/news/') {
                    // Allow the iterator to continue
                    return true;
                } else {
                    if ($navLink.next().hasClass('pageBanner')) {
                        initBanner($navLink.next(), $navBasedPageBanner);
                    } else if ($navLink.closest('.pageBanner').length > 0) {
                        initBanner($navLink.closest('.pageBanner'), $navBasedPageBanner);
                    }
                    // Stop the iterator
                    return false;
                }
            }
            // Allow the iterator to continue
            return true;
        });
    }

    function initBanner($banner, $navBasedPageBanner) {
        var $bannerNav = $banner.find('.nav');
        var $existingPageBanner = $navBasedPageBanner.next();

        if ($bannerNav.find('li').length) {
            // Inject the banner's nav into the existing banner
            $existingPageBanner
            .hide()
            .addClass('pageBannerWithTertiaryNav')
            .find('.container')
            .append($bannerNav.clone())
            .end()
            .show();
        }
    }

    function localBanners(){
        // fragment divs
        var $localBannerInsert = $('.local-banner-insert');
        var $localBannerInsertPageSection = $('.local-banner-insert-pageSection');
        var $banner, $clonedBanner;

        if($localBannerInsert.length){
            $banner = $('.secondaryNav .nav-pills li .rnn_page_banner_local');
            $clonedBanner = $banner.clone();
            $clonedBanner.appendTo('.sitenav .navBasedPageBanner');
            $clonedBanner.addClass('clonedBanner');

            $('.clonedBanner .container .row .span8').html('');
            $localBannerInsert.appendTo('.clonedBanner .container .row .span8');
        }

        if($localBannerInsertPageSection.length){
            // need to check if the page section is already loading a banner in.
            // if so, over-write it. if not, create it from scratch.

            if($('.sitenav .navBasedPageBanner .pageBanner .container .row .span8').length){
                $('.sitenav .navBasedPageBanner .pageBanner .container .row .span8').html('');
                $localBannerInsertPageSection.appendTo('.sitenav .navBasedPageBanner .pageBanner .container .row .span8');
            }else{
                $banner = $('.secondaryNav .nav-pills li .rnn_page_banner_local');
                $clonedBanner = $banner.clone();
                $clonedBanner.appendTo('.sitenav .navBasedPageBanner');
                $clonedBanner.addClass('clonedBanner');

                $('.clonedBanner .container .row .span8').html('');
                $localBannerInsertPageSection.appendTo('.clonedBanner .container .row .span8');
            }
        }
    }

    rnn.modules.register("treeMenu", {
        init: initTreeMenu
    });

})(jQuery);
